// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3lxJu","content":"styles_content__3aaxu","checkbox":"styles_checkbox__14aQs","checkboxLabel":"styles_checkboxLabel__2YBkN"};